import { Component, OnDestroy, OnInit } from '@angular/core';

import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';

import { TranslocoService } from '@jsverse/transloco';

import { Subject, takeUntil } from 'rxjs';

import { HasTitle } from 'app/has-title';
import { ActionPlan } from 'app/providers/storage-api/actionplan.service';
import { LocalStorageKey, LocalStorageService } from 'app/services/local-storage.service';

import {
  injectComponentTelemetryService,
  EnableComponentTelemetry,
  EnableClassTelemetry,
} from 'app/services/otel.service';

@EnableClassTelemetry()
@Component({
  selector: 'app-action-plan-list',
  templateUrl: './action-plan-list.component.html',
  styleUrls: ['./action-plan-list.component.scss'],
  standalone: false,
})
export class ActionPlanListComponent extends HasTitle implements OnInit, OnDestroy {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();

  isPanelOpen: boolean;

  private readonly destroy$ = new Subject<void>();

  constructor(
    title: Title,
    private localStorageService: LocalStorageService,
    private router: Router,
    private route: ActivatedRoute,
    private translocoService: TranslocoService
  ) {
    super(title);

    this.isPanelOpen = false;
  }

  ngOnInit(): void {
    this.translocoService
      .selectTranslateObject('action-plan-list-component')
      .pipe(takeUntil(this.destroy$))
      .subscribe((translations) => {
        this.setTitle(translations['action-plans']);
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onPanelStateChange(isOpen: boolean) {
    this.localStorageService.setItem(LocalStorageKey.ACTION_PLANS_PANEL_OPEN, isOpen);
  }

  onNavigateDetails(actionPlan: ActionPlan, edit: boolean): void {
    this.router.navigate([`./${actionPlan.plan_id}`], {
      relativeTo: this.route,
      queryParams: { edit },
    });
  }
}
